/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'

const http = {
  postFormatter (url, params) {
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    const formData = new FormData()
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        formData.append(key, params[key])
      }
    }
    return request.post(url, formData, config)
  },

  post (url, params) {
    return request.post(url, params)
  },
}
//导出
export default http



// WEBPACK FOOTER //
// ./src/utils/http.js